/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */
import React from 'react';
import {SpeciesIndexPage} from "../Common/SpeciesIndexPage";
import {
	commonName, dateRequested,
	requester, reviewAction,
	scientificName, speciesRequestStatus
} from "../Common/SpeciesTable/ColumnDefinitions";
import {ReviewSpeciesModal} from "../Common/Modals/ReviewSpeciesModal";
import {SpeciesRequestTableFilter} from "../SpeciesRequests/SpeciesRequestTableFilter";
import {service as SpeciesService} from "../../../../Services/SpeciesService";
import {usePermission} from "../../../../Hooks/PermissionHooks";
import {ViewSpeciesModal} from "../Common/Modals/ViewSpeciesModal";
import {SpeciesRequestModal} from "../Common/Modals/SpeciesRequestModal";

export const SpeciesRequestsPage = props => {
	const permission = usePermission();
	const canEdit = permission?.('can_alter_global_species_list');
	
	return <SpeciesIndexPage
		title="Species Requests"
		columnDefinitions={[
			scientificName,
			commonName,
			requester,
			dateRequested,
			speciesRequestStatus,
			reviewAction,
		]}
		filterComponent={SpeciesRequestTableFilter}
		addModalComponent={SpeciesRequestModal}
		addSpeciesButtonLabel={"Request A New Species"}
		editModalComponent={canEdit ? ReviewSpeciesModal : ViewSpeciesModal}
		sortColumn="none" // default to sort provided by API which is a bit more complicated
		getSpeciesPromise={(_ => SpeciesService.GetSpeciesRequests())}
		{...props}
	/>;
};
